export default __webpack_public_path__ + "static/img/return_approval.3efd76e.svg";